/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'
import App from './App.vue'
import environment from './utils/constants';

import 'document-register-element/build/document-register-element';

import Chat from 'vue-beautiful-chat'
Vue.use(Chat)

import Toasted from 'vue-toasted';

Vue.use(Toasted)

// Vuesax Component Framework
// import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
// Vue.use(Vuesax)
// Bootstrap
import {
  BootstrapVue,
  IconsPlugin,
} from 'bootstrap-vue'


// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
// Theme Configurations
import '../themeConfig.js'

// Globally Registered Components
import './globalComponents.js'

// Styles: SCSS
import './assets/scss/main.scss'

// Tailwind
import '@/assets/css/main.css'

// Vue Router
import router from './router'

// Vuex Store
import store from './store'

// Error Logger
import Logger from './logger';

// Vuexy Admin Filters
import './filters/filters'

// mock
import './fake-db/index.js'
import VueTelInput from 'vue-tel-input'

Vue.use(VueTelInput);

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

// axios
import axios from './axios.js'
Vue.prototype.$http = axios

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// Feather font icon
require('./assets/css/iconfont.css')

// i18n
import i18n from './i18n/i18n'

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

// VeeValidate
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

//moment for date
Vue.use(require('vue-moment'))
//Dropdown added
import { DropDownListPlugin } from '@syncfusion/ej2-vue-dropdowns';

Vue.use(DropDownListPlugin);

// sweetalert
import VueSweetalert2 from 'vue-sweetalert2';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

import CKEditor from 'ckeditor4-vue';
Vue.use( CKEditor );

Vue.config.productionTip = false

// Use logger
Vue.use(Logger);

import FunctionalCalendar from 'vue-functional-calendar';
Vue.use(FunctionalCalendar);

import VueSlimScroll from 'vue-slimscroll'
Vue.use(VueSlimScroll)

import autolinker, { AUTOLINKER_NAME } from 'vue-autolinker'
autolinker.update = autolinker.bind;
Vue.directive(AUTOLINKER_NAME, autolinker);

import vueCustomElement from 'vue-custom-element'
Vue.use(vueCustomElement)

import Echo from "laravel-echo"
window.io = require('socket.io-client');

// window.Echo = new Echo({
//   broadcaster: 'socket.io',
//   host: 'https://teleconsulto.incontradonnadigitale.it' + ':443' // 'https://www.meet.confhub.live' + ':443 // this is laravel-echo-server host
// });

window.Echo = new Echo({
  broadcaster: 'socket.io',
  host: `${environment.SOCKET_HOST}:${environment.SOCKET_PORT}`, // this is laravel-echo-server host 443 prod
  auth: {
    headers: {
      Authorization: null
    }
  }

});

App.store = store
App.router = router
App.i18n = i18n
Vue.customElement('appointment-widget', App);


if(window.parent) {
  setInterval(() => {
    const message = { height: document.body.scrollHeight, width: document.body.scrollWidth };
    window.parent.postMessage(message, "*");
  }, 1000);
}
